import { Booking } from '../types/bookingTypes';

export const appointmentTimeToMinutes = (time?: string): number => {
  const normalizedTime = String(time || '').trim();
  if (!normalizedTime) return Number.MAX_SAFE_INTEGER;

  const twelveHourMatch = normalizedTime.match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
  if (twelveHourMatch) {
    let hour = Number(twelveHourMatch[1]);
    const minute = Number(twelveHourMatch[2]);
    const period = twelveHourMatch[3].toUpperCase();

    if (hour < 1 || hour > 12 || minute > 59) return Number.MAX_SAFE_INTEGER;
    if (period === 'PM' && hour !== 12) hour += 12;
    if (period === 'AM' && hour === 12) hour = 0;

    return hour * 60 + minute;
  }

  const twentyFourHourMatch = normalizedTime.match(/^(\d{1,2}):(\d{2})$/);
  if (twentyFourHourMatch) {
    const hour = Number(twentyFourHourMatch[1]);
    const minute = Number(twentyFourHourMatch[2]);
    if (hour <= 23 && minute <= 59) return hour * 60 + minute;
  }

  return Number.MAX_SAFE_INTEGER;
};

export const compareBookingsByAppointmentTime = (first: Booking, second: Booking): number =>
  appointmentTimeToMinutes(first.consultationTime)
  - appointmentTimeToMinutes(second.consultationTime);
